// extracted by mini-css-extract-plugin
export default {"button":"button__3xm2q","button_disabled":"button_disabled__2LnfW","button__loader":"button__loader__1PSq_","skeleton-shimmer":"skeleton-shimmer__2x1WX"};